import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared';
import { AuthorizeNetCheckoutRoute } from './authorizenet-checkout.route';

@NgModule({
    // declarations: [],
    providers: [],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [AuthorizeNetCheckoutRoute]
        })
    ]
})
export class AuthorizeNetCheckoutModule {
    constructor() {}
}
